<div class="storeSubbox">
  <section>
    <h2>Filialdoku bearbeiten</h2>
    <p>hier kann die Filialdoku bearbeitet werden.</p>

    <section>
      <h2>Untereinheit auswählen</h2>
      <p>Hier die Abteilung/Kasse auswählen</p>
      <p>
        ausgewählt:
        @if (selectedStoreUnit) {
          <span>{{ selectedStoreUnit.label }}</span>
        }
        @if (!selectedStoreUnit) {
          <span>(keine)</span>
        }
        @if (!storeUnitSelection) {
          <button (click)="toggleUnitSelection()">Auswahl öffnen</button>
        }
        @if (storeUnitSelection) {
          <button (click)="toggleUnitSelection()">Auswahl schließen</button>
        }
      </p>
      @if (storeUnitSelection) {
        <button (click)="createUnit()">Einheit anlegen</button>
        <p>
          @for (unit of storeUnits; track unit) {
            <button (click)="selectStoreUnit(unit)">{{ unit.label }} auswählen</button>
          }
        </p>
      }
    </section>

    @if (selectedStoreUnit && selectedStep) {
      <section>
        <p style="font-weight: bold">Info in Abteilung übernehmen</p>
        @if (!tempStoreUnit) {
          <button (click)="transformInput()">Alles übernehmen</button>
        }
        @if (!!tempStoreUnit) {
          <button (click)="unsetTempStore()">zurücksetzen</button>
        }
        @if (!selectedStoreUnit) {
          <p>Keine Abteilung ausgewählt</p>
        }
        @if (selectedStoreUnit && selectedStep) {
          <div class="columns">
            <div style="height: 100%">
              <p style="font-weight: bold">Überblick</p>
              <table class="storeUnitTable">
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Store Id', key: 'store_id', mode: 'global' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Bezeichnung', key: 'label', mode: 'global' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Typ', key: 'unit_type', mode: 'global' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Nummer', key: 'unit_id', mode: 'global' }"
                ></ng-container>
              </table>
              <p style="font-weight: bold">Kasse</p>
              <table class="storeUnitTable">
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Hersteller', key: 'vendor', mode: 'checkout' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Typ', key: 'checkout_type', mode: 'checkout' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'SN', key: 'sn', mode: 'checkout' }"
                ></ng-container>
              </table>
              <p style="font-weight: bold">Scanner</p>
              <table class="storeUnitTable">
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Hersteller', key: 'vendor', mode: 'scanner' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Typ', key: 'scanner_type', mode: 'scanner' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'SN', key: 'sn', mode: 'scanner' }"
                ></ng-container>
              </table>
              <p style="font-weight: bold">Waage</p>
              <table class="storeUnitTable">
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Hersteller', key: 'vendor', mode: 'scale' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Typ', key: 'scale_type', mode: 'scale' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'SN', key: 'sn', mode: 'scale' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="
                    stepRowValue;
                    context: { title: 'letzte Eichung', key: 'last_calibration', mode: 'global' }
                  "
                ></ng-container>
                <tr>
                  <td style="width: 50%">Eichungen</td>
                  @if (tempStoreUnit) {
                    <td style="width: 50%">
                      @for (
                        calibration of tempStoreUnit.additional_information?.scale_calibrations;
                        track calibration
                      ) {
                        <span
                          >{{ calibration.year }} ({{ translateCalibrationType(calibration.calibration_type) }}),
                        </span>
                      }
                    </td>
                  }
                </tr>
              </table>
              <p style="font-weight: bold">Telefonanlage</p>
              <table class="storeUnitTable">
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Hersteller', key: 'vendor', mode: 'phone' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'Typ', key: 'ps_type', mode: 'phone' }"
                ></ng-container>
                <ng-container
                  *ngTemplateOutlet="stepRowValue; context: { title: 'SN', key: 'sn', mode: 'phone' }"
                ></ng-container>
              </table>
              <p style="font-weight: bold">Bilder</p>
              @if (combineImages().length === 0) {
                <p>noch keine Bilder hinterlegt</p>
              }
              <table class="storeUnitTable">
                @for (image of combineImages(); track image) {
                  <ng-container *ngTemplateOutlet="stepImage; context: { image: image }"></ng-container>
                }
              </table>
            </div>
            <div>
              <p style="font-weight: bold">Schrittinfo für: {{ selectedStep.name }}</p>
              <table>
                @for (step of selectedStep.steps; track step) {
                  <tr>
                    <td>{{ step.name }}</td>
                    <td>{{ step.value }}</td>
                  </tr>
                }
              </table>
              <button (click)="debugggg(selectedStep)">debug</button>
            </div>
          </div>
          <div class="columns">
            <p><button (click)="saveToServer()">Auf Server speichern</button></p>
            <p><button (click)="unselectStoreUnit()">Ansicht schließen</button></p>
          </div>
          <div class="columns">
            <pre>
                selectedStoreUnit:<br>
                {{selectedStoreUnit | json}}
              </pre>
            <pre>
                tempStoreUnit:<br>
                {{tempStoreUnit | json}}
              </pre>
          </div>
        }
      </section>
    }
  </section>
</div>

<ng-template #stepRowValue let-key="key" let-title="title" let-mode="mode">
  <tr>
    <td style="width: 50%">{{ title }}</td>
    <td style="width: 50%">
      @if (docuValueDiffers(mode, key)) {
        @if (!docuHasNoValue) {
          <span class="deleted">{{ docuGetStoreUnitValue(mode, key) }}</span>
        } @else {
          <span class="deleted">keine Angabe</span>
        }
        <br /><span class="updated">{{ docuGetTmpStoreUnitValue(mode, key) }}</span>
      } @else {
        @if (!docuHasNoValue(mode, key)) {
          <span class="unchanged">{{ docuGetStoreUnitValue(mode, key) }}</span>
        } @else {
          <span class="unchanged">keine Angabe</span>
        }
      }
    </td>
  </tr>
</ng-template>

<ng-template #stepImage let-image="image">
  <tr>
    <td colspan="2">{{ image.title }}</td>
  </tr>
  <tr>
    @if (image.current_path) {
      <td style="width: 50%">
        <a [href]="image.current_path" target="_blank"><img style="width: 50%" [attr.src]="image.current_path" /> </a>
      </td>
    }
    @if (!image.current_path) {
      <td style="width: 50%" class="deleted">kein Bild</td>
    }
    @if (image.new_path) {
      <td style="width: 50%">
        <a [href]="image.new_path" target="_blank"><img style="width: 50%" [attr.src]="image.new_path" /> </a>
      </td>
    }
    @if (!image.new_path) {
      <td style="width: 50%" class="updated">kein Bild</td>
    }
  </tr>
</ng-template>
